import React, { useEffect, useState } from "react";
import { getIssues, WarehouseIssueDto } from "../../../api/warehouseIssues";
import IssueModal from "../modals/IssueModal";

const REASON_LABELS: Record<string, string> = {
  damage:   "Порча",
  expired:  "Срок годности",
  theft:    "Кража",
  defect:   "Брак",
  loss:     "Недостача",
  writeoff: "Списание",
  error:    "Ошибка учёта",
  other:    "Прочее",
};

export default function IssuesTab() {
  const [items, setItems] = useState<WarehouseIssueDto[]>([]);
  const [modalId, setModalId] = useState<number | null | undefined>(undefined); // undefined=закрыта, null=новая

  async function load() {
    const res = await getIssues();
    setItems(res ?? []);
  }

  useEffect(() => { load(); }, []);

  const totalPosted = items.filter(i => i.posted).length;
  const totalItems  = items.reduce((s, i) => s + (i.items?.length ?? 0), 0);

  return (
    <div className="warehouse-issues-tab">

      {/* Header */}
      <div className="issues-header">
        <div className="issues-header-info">
          <h2 className="issues-title">Расход / Списания</h2>
          <div className="issues-stats">
            <span>{items.length} документов</span>
            <span className="issues-stats-dot">·</span>
            <span>{totalPosted} проведено</span>
            <span className="issues-stats-dot">·</span>
            <span>{totalItems} позиций</span>
          </div>
        </div>
        <button className="issues-create-btn" onClick={() => setModalId(null)}>
          + Новое списание
        </button>
      </div>

      {/* Десктоп — таблица */}
      <div className="receipt-items-desktop" style={{ padding: "0 20px 20px" }}>
        <table className="stock-table">
          <thead>
            <tr>
              <th>№</th>
              <th>Дата</th>
              <th>Причина</th>
              <th>Позиции</th>
              <th>Статус</th>
              <th>Комментарий</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {items.length === 0 && (
              <tr><td colSpan={7} style={{ textAlign: "center", padding: 32, color: "#6b7280" }}>Нет документов</td></tr>
            )}
            {items.map((r) => (
              <tr key={r.id} style={{ cursor: "pointer" }} onClick={() => setModalId(r.id)}>
                <td style={{ fontWeight: 600, color: "#818cf8" }}>#{r.id}</td>
                <td>{new Date(r.date || r.createdAt).toLocaleDateString("ru-RU")}</td>
                <td>
                  <span className="issue-reason-chip">
                    {REASON_LABELS[r.reason ?? ""] ?? r.reason ?? "—"}
                  </span>
                </td>
                <td>{r.items?.length ?? 0} поз.</td>
                <td>
                  {r.posted
                    ? <span className="tag-in">Проведён</span>
                    : <span className="tag-out">Черновик</span>}
                </td>
                <td style={{ color: "#6b7280", fontSize: 12 }}>{r.comment ?? "—"}</td>
                <td onClick={e => e.stopPropagation()}>
                  <div style={{ display: "flex", gap: 6 }}>
                    <button className="table-btn" onClick={() => setModalId(r.id)}>Открыть</button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Мобильный — карточки */}
      <div className="receipt-items-mobile" style={{ padding: "0 12px 16px" }}>
        {items.length === 0 && (
          <div style={{ textAlign: "center", padding: 32, color: "#6b7280" }}>Нет документов</div>
        )}
        {items.map((r) => (
          <div key={r.id} className="issue-card" onClick={() => setModalId(r.id)}>
            <div className="issue-card-row">
              <span className="issue-card-num">Списание #{r.id}</span>
              {r.posted
                ? <span className="issue-card-status posted">Проведён</span>
                : <span className="issue-card-status draft">Черновик</span>}
            </div>
            <div className="issue-card-row" style={{ marginTop: 6 }}>
              <span className="issue-reason-chip">
                {REASON_LABELS[r.reason ?? ""] ?? r.reason ?? "Без причины"}
              </span>
              <span style={{ color: "#6b7280", fontSize: 12 }}>
                {r.items?.length ?? 0} поз.
              </span>
            </div>
            <div style={{ color: "#6b7280", fontSize: 12, marginTop: 4 }}>
              {new Date(r.date || r.createdAt).toLocaleDateString("ru-RU")}
              {r.comment && <span> · {r.comment}</span>}
            </div>
          </div>
        ))}
      </div>

      {/* Модалка */}
      {modalId !== undefined && (
        <IssueModal
          id={modalId}
          onClose={() => setModalId(undefined)}
          onSaved={load}
        />
      )}
    </div>
  );
}
